// Normalização de imóveis externos (catálogo/empreendimentos) para o payload
// interno de Imóvel usado ao materializar um imóvel no fluxo de relatório.
// Extraído de RelatorioIndex.vue sem alteração de contrato.

export const valueFrom = (item, ...keys) => {
  if (!item) return '';
  const attrs = item.additional_attributes || item.additionalAttributes || {};
  const match = keys.find(
    key =>
      (item[key] != null && item[key] !== '') ||
      (attrs[key] != null && attrs[key] !== '')
  );
  if (!match) return '';
  return item[match] != null && item[match] !== '' ? item[match] : attrs[match];
};

export const normalizedTipo = value => {
  const normalized = String(value || '').toLowerCase();
  return (
    {
      apartment: 'apartamento',
      apartamento: 'apartamento',
      house: 'casa',
      casa: 'casa',
      townhouse: 'casa_condominio',
      casa_condominio: 'casa_condominio',
      penthouse: 'cobertura',
      cobertura: 'cobertura',
      studio: 'studio',
      loft: 'loft',
      flat: 'flat',
      land: 'terreno',
      terreno: 'terreno',
      commercial: 'comercial',
      comercial: 'comercial',
      office: 'sala_comercial',
      sala_comercial: 'sala_comercial',
    }[normalized] || 'apartamento'
  );
};

export const normalizedFinalidade = (item, fallbackFinalidade) => {
  const value = String(
    valueFrom(item, 'finalidade', 'transaction_type', 'transactionType') ||
      fallbackFinalidade
  ).toLowerCase();
  if (['rent', 'rental', 'aluguel'].includes(value)) return 'aluguel';
  if (['season', 'temporada'].includes(value)) return 'temporada';
  return 'venda';
};

export const mediaFrom = item => {
  const media = valueFrom(item, 'midias', 'media', 'images', 'photos') || [];
  return Array.isArray(media)
    ? media.map(entry => (typeof entry === 'string' ? { url: entry } : entry))
    : [];
};

export const titleFrom = item =>
  valueFrom(item, 'titulo', 'title', 'name', 'address') || 'Imóvel externo';

export const linkFrom = item =>
  valueFrom(
    item,
    'link_externo',
    'linkExterno',
    'external_url',
    'externalUrl',
    'public_url',
    'publicUrl',
    'contactWebsite',
    'url'
  );

export const normalizedExternalImovelPayload = (
  item,
  source,
  fallbackFinalidade
) => {
  const externalId = valueFrom(item, 'external_id', 'externalId', 'id');
  return {
    external_id: externalId ? String(externalId) : null,
    titulo: titleFrom(item),
    descricao: valueFrom(item, 'descricao', 'description'),
    tipo: normalizedTipo(valueFrom(item, 'tipo', 'type')),
    finalidade: normalizedFinalidade(item, fallbackFinalidade),
    status: valueFrom(item, 'status') || 'disponivel',
    valor_venda: valueFrom(
      item,
      'valor_venda',
      'valorVenda',
      'sale_price',
      'salePrice',
      'price'
    ),
    valor_aluguel: valueFrom(
      item,
      'valor_aluguel',
      'valorAluguel',
      'rent_price',
      'rentPrice'
    ),
    valor_iptu: valueFrom(item, 'valor_iptu', 'valorIptu', 'property_tax'),
    valor_condominio: valueFrom(
      item,
      'valor_condominio',
      'valorCondominio',
      'condo_price'
    ),
    quartos: valueFrom(item, 'quartos', 'bedrooms'),
    banheiros: valueFrom(item, 'banheiros', 'bathrooms'),
    vagas_garagem: valueFrom(item, 'vagas_garagem', 'vagasGaragem', 'parking'),
    area_util: valueFrom(item, 'area_util', 'areaUtil', 'usable_area'),
    area_total: valueFrom(item, 'area_total', 'areaTotal', 'total_area'),
    endereco: valueFrom(item, 'endereco', 'address', 'street'),
    bairro: valueFrom(item, 'bairro', 'neighborhood'),
    cidade: valueFrom(item, 'cidade', 'city'),
    uf: valueFrom(item, 'uf', 'state'),
    cep: valueFrom(item, 'cep', 'zip_code', 'zipCode'),
    latitude: valueFrom(item, 'latitude', 'lat'),
    longitude: valueFrom(item, 'longitude', 'lng'),
    portal_origem:
      valueFrom(item, 'portal_origem', 'portalOrigem') ||
      (source === 'properties' ? 'imobiliaria-api.Properties' : source),
    link_externo: linkFrom(item),
    midias: mediaFrom(item),
    caracteristicas:
      valueFrom(item, 'caracteristicas', 'features', 'amenities') || [],
    additional_attributes: {
      ...(valueFrom(item, 'additional_attributes', 'additionalAttributes') ||
        {}),
      materialized_from_catalog: source,
      materialized_for: 'report_flow',
    },
  };
};
